<div *ngIf="dataSource$ | async as dataSource" style="display: flex; flex-direction: column; height: 100%;">
	<div style="flex-grow: 1; display: flex; flex-direction: column; overflow: hidden;">
		<div style="padding: 0 35px; flex-grow: 1; overflow-y: auto;">
			<div *ngIf="dataSource.data.length > 0" style="overflow: visible;">
				<table mat-table [dataSource]="dataSource" class="table-width"
					   [trackBy]="trackByFn" style="width: 100%; border-spacing: 0 3px; background: transparent;">
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef style="width: 50px; font-size: 14px"></th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<div style="display: flex; gap: 12px; justify-content: flex-start; align-items: center;">
								<div class="status-icon-wrapper">
									@if (serviceTableRow.isHealthy) {
										<div class="far fa-heart-pulse success-icon" style="font-size: 16px;" matTooltip="Services are healthy."></div>
									} @else {
										<div class="far fa-circle-exclamation warn-icon" style="font-size: 16px;" matTooltip="One or more issues detected in service health."></div>
									}
								</div>
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="serviceCounts">
						<th mat-header-cell *matHeaderCellDef style="font-size: 14px">Active / Max</th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<div style="display: flex; justify-content: flex-start; align-items: center;">
								<div [ngClass]="{'active': serviceTableRow.activeServiceCount > 0, 'container-burst' : serviceTableRow.maxServiceCount && serviceTableRow.totalServiceCount > serviceTableRow.maxServiceCount }"
									 class="activity-badge container-burst">
									<div class="status-icon-wrapper">
										@if (serviceTableRow.maxServiceCount && serviceTableRow.totalServiceCount > serviceTableRow.maxServiceCount) {
											<div class="fas fa-fire" matTooltip="Container Burst. Services scaling beyond standard capacity to complete a workload."></div>
										} @else if (serviceTableRow.activeServiceCount > 0) {
											<div class="fas fa-circle-small" matTooltip="Work in progress. Services are active."></div>
										} @else {
											<div class="fad fa-moon-stars" matTooltip="No work is currently in progress. Services are idle."></div>
										}
									</div>
									<div style="display:flex; align-items: center; gap: 3px;">
										@if (serviceTableRow.isOperationReportingEnabled) {
											{{ serviceTableRow.activeServiceCount | number }} / {{ serviceTableRow.totalServiceCount | number }}
										} @else {
											<div class="fas fa-infinity" style="font-size: 10px; "></div> / {{ serviceTableRow.totalServiceCount | number }}
										}
									</div>
								</div>
								<div style="flex-grow: 1"></div>
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="serviceName">
						<th mat-header-cell *matHeaderCellDef style=" font-size: 14px">Service</th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<div style="width: 250px;">
								{{ serviceTableRow.serviceName }}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="assemblyVersions">
						<th mat-header-cell *matHeaderCellDef style="font-size: 14px">Versions</th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<div style="min-width: 275px; white-space: nowrap; width: 100%;">
								{{ serviceTableRow.assemblyVersions.join(' | ') }}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="currentOperations">
						<th mat-header-cell *matHeaderCellDef style="width: 100%; font-size: 14px">Current Operations</th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<span>{{ serviceTableRow.currentOperations.join(' | ') }}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="settings">
						<th mat-header-cell *matHeaderCellDef style="width: 100%; font-size: 14px; text-align: right;"></th>
						<td mat-cell *matCellDef="let serviceTableRow" [style.height.px]="rowHeight$ | async" style="font-size: 14px">
							<div style="display:flex; align-items: center; justify-content: center; gap: 10px;" *inRole="[roles.Administrator]">
								<div class="fa fa-refresh primary-icon" style="cursor:pointer;" (click)="refreshServices(serviceTableRow)"></div>
								<div class="fa fa-gauge-max primary-icon" style="cursor:pointer;" (click)="openServiceScalingDialog(serviceTableRow)"></div>
							</div>
						</td>
					</ng-container>
					<tbody    >
					<tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
					<tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay" [ngClass]="{'active': row.activeServiceCount > 0, 'container-burst': (row.maxServiceCount && row.totalServiceCount > row.maxServiceCount)}"
						[style.height.px]="rowHeight$ | async"></tr>
					</tbody>
				</table>
			</div>
			<div *ngIf="dataSource.data.length < 1">
				<div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
					<span class="fal fa-binary-circle-check"></span>
					<span style="padding-left: 10px;">No Microservices running at this time.</span>
				</div>
			</div>
		</div>
	</div>
</div>
